import {
  LiveClassRubricsResponse,
  LiveClassRubricsService,
} from '@openeducation/oe-it-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

export interface UseRubricsProps {
  lessonId?: number;
}

export const useLiveClassRubrics = ({ lessonId }: UseRubricsProps) => {
  const { environment } = useEnvironmentContext();

  const { data, isLoading, isError } = useQuery<LiveClassRubricsResponse>(
    ['liveclassrubrics', lessonId],
    () => LiveClassRubricsService.getLiveClassRubrics(environment, lessonId),
    {
      enabled: !!lessonId,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};
